<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <UsersDropDownList
          label="Team Member"
          :userId="memberIdValue"
          :isRequired="true"
          :securityRoles="[ADMIN, MANAGER, RECRUITER, SALES_PERSON]"
          @userIdChange="handleMemberIdChange"
          @userRoleChange="handleUserRoleChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="9" sm="4">
        <BusinessRolesDropDownList
          :businessRoles="roleValue"
          :multiple="false"
          @businessRolesChange="handleBusinessRoleChange"
        ></BusinessRolesDropDownList>
      </v-col>
      <v-col cols="3" sm="2" v-if="showDeleteButton">
        <v-btn
          outlined color="error"
          @click="$emit('removeMember', id)">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SimpleDatePicker } from '@/components/shared/datePickers'
import UsersDropDownList from '@/components/users/UsersDropDownList'
import BusinessRolesDropDownList from '@/components/securityRoles/BusinessRolesDropDownList'
import { ADMIN, MANAGER, RECRUITER, SALES_PERSON } from '@/lib/constants/securityRoles'

export default {
  components: {
    BusinessRolesDropDownList,
    UsersDropDownList,
    SimpleDatePicker
  },
  data () {
    return {
      ADMIN,
      MANAGER,
      RECRUITER,
      SALES_PERSON
    }
  },
  props: [
    'id',
    'memberId',
    'role',
    'showDeleteButton'
  ],
  computed: {
    memberIdValue: {
      get () {
        return this.memberId
      },
      set (newValue) {
        this.$emit('memberIdChange', { id: this.id, memberId: newValue })
      }
    },
    roleValue: {
      get () {
        return this.role
      },
      set (newValue) {
        this.$emit('roleChange', { id: this.id, role: newValue })
      }
    }
  },
  methods: {
    handleMemberIdChange (newValue) {
      this.memberIdValue = newValue
    },
    handleBusinessRoleChange (newValue) {
      this.roleValue = newValue
    },
    handleUserRoleChange (securityRoles) {
      let role = securityRoles.find(role => role === 'RECRUITER' || role === 'SALES_PERSON')
      if (role) {
        this.roleValue = role
      }
    }
  }
}
</script>
